import { render, staticRenderFns } from "./claim_detail_m.vue?vue&type=template&id=641aac76&scoped=true&"
import script from "./claim_detail_m.vue?vue&type=script&lang=js&"
export * from "./claim_detail_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641aac76",
  null
  
)

export default component.exports